export default function makeCategoryLink(text, url) {
    return ['Powrót',[text],[url]]
}